import {
    CatalogApiObject,
    CatalogsFull,
    DossierJsonldRead,
    DossierPrestationJsonldRead,
    FormulaireFormaliteApiObject,
    Prescripteur,
    SousClientApi,
} from '@europrocurement/l2d-domain';
import {
    CollectionDeDossierCollectiondossierRead,
    CollectionDeDossierJsonldCollectiondossierCreated,
    CollectionDeDossierJsonldCollectiondossierRead,
    CollectionDeDossierJsonldCollectiondossierValidated,
    FproPrestationJsonldCollectiondossierCreated,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { Breakpoint } from '@mui/material';
import { AxiosResponse } from 'axios';
import { createContext } from 'react';

export type ParcoursFormaliteContextType = {
    // data
    loading: boolean;
    prescripteur?: Prescripteur;
    prescripteurId?: number;
    currentCollectionId: number;
    currentDossierId: number;
    currentPrestaId: number;
    currentCatalog?: CatalogsFull;
    currentCatalogs?: CatalogApiObject[];
    currentCatalogId?: number;
    collections: {
        [idSousClient: number]: CollectionDeDossierJsonldCollectiondossierRead;
    };
    dossiers: {
        [idSousClient: number]: DossierJsonldRead;
    };
    prestas: Array<DossierPrestationJsonldRead | FproPrestationJsonldCollectiondossierCreated>;
    idFormalites: Array<number>;
    idSousClients: Array<number>;
    currentSousClient: SousClientApi | undefined;
    form: FormulaireFormaliteApiObject | null;
    formLoading: boolean;
    fetchForm: (
        innerPresta?:
            | DossierPrestationJsonldRead
            | FproPrestationJsonldCollectiondossierCreated
            | null,
    ) => void;
    setForm: (form: FormulaireFormaliteApiObject) => void;
    // manipulation
    getPrescripteur: () => Prescripteur | undefined;
    getCurrentCollection: () => CollectionDeDossierJsonldCollectiondossierRead | null;
    getCurrentDossier: () => DossierJsonldRead | null;
    getCurrentPresta: () =>
        | DossierPrestationJsonldRead
        | FproPrestationJsonldCollectiondossierCreated
        | null;
    getCollections: () => {
        [idSousClient: number]: CollectionDeDossierJsonldCollectiondossierRead;
    };
    setCollections: (collections: {
        [idSousClient: number]: CollectionDeDossierJsonldCollectiondossierRead;
    }) => void;
    refreshDossier: (id: number) => void;
    // Checks
    isFormaliteSimple: () => boolean;
    isFormaliteCombinee: () => boolean;
    isFormaliteMultiple: () => boolean;
    isFormaliteDupliquee: () => boolean;
    isNextPresta: () => boolean;
    switchToPresta: (
        indexPresta: number,
    ) => Promise<
        false | DossierPrestationJsonldRead | FproPrestationJsonldCollectiondossierCreated
    >;
    setLoading: (loading: boolean) => void;
    setIdFormalites: (ids: Array<number>) => void;
    setIdSousClients: (ids: Array<number>) => void;
    setCurrentCatalog: (catalog: CatalogsFull) => void;
    setCurrentCatalogs: (catalogs: CatalogApiObject[]) => void;
    setCurrentCatalogId: (catalogId: number) => void;
    save: () => void;
    contact?: ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup;
    setContact: (
        contact: ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup | undefined,
    ) => void;
    create: (
        newIdSousClients: Array<number | undefined>,
        newIdFormalite: Array<number | undefined>,
        sousClient: SousClientApi,
        sousClientOpere?: SousClientApi,
    ) => Promise<CollectionDeDossierJsonldCollectiondossierCreated>;
    validate: (
        collection:
            | CollectionDeDossierCollectiondossierRead
            | CollectionDeDossierJsonldCollectiondossierCreated
            | null,
    ) => Promise<AxiosResponse<CollectionDeDossierJsonldCollectiondossierValidated>>;
    containerWidth: Breakpoint;
    back: boolean;
};

const fakePrescripteur = {
    idPrescripteur: -1,
    raisonSociale: 'Temp',
    adresses: [],
    contacts: [],
    personnePhysique: false,
    origine: {},
    relationsSocietes: [],
};

export const ParcoursFormaliteContext = createContext<ParcoursFormaliteContextType>({
    loading: false,
    prescripteur: fakePrescripteur,
    collections: {},
    dossiers: {},
    currentCollectionId: -1,
    currentDossierId: -1,
    prescripteurId: -1,
    currentPrestaId: -1,
    idFormalites: [],
    prestas: [],
    idSousClients: [],
    currentCatalogs: [],
    form: null,
    currentSousClient: undefined,
    formLoading: false,
    contact: undefined,
    setContact: () => null,
    fetchForm: () => null,
    setForm: () => fakePrescripteur,
    getPrescripteur: () => fakePrescripteur,
    getCurrentCollection: () => null,
    getCurrentDossier: () => null,
    getCollections: () => [],
    isFormaliteSimple: () => false,
    isFormaliteCombinee: () => false,
    isFormaliteMultiple: () => false,
    isFormaliteDupliquee: () => false,
    getCurrentPresta: () => null,
    refreshDossier: () => null,
    setCollections: () => null,
    setIdFormalites: () => null,
    setIdSousClients: () => null,
    setCurrentCatalog: () => null,
    setCurrentCatalogs: () => null,
    isNextPresta: () => false,
    switchToPresta: () => Promise.resolve(false),
    setCurrentCatalogId: () => null,
    save: () => null,
    create: () => ({}) as Promise<CollectionDeDossierJsonldCollectiondossierCreated>,
    validate: () =>
        ({}) as Promise<AxiosResponse<CollectionDeDossierJsonldCollectiondossierValidated>>,
    setLoading: () => null,
    containerWidth: 'sm',
    back: false,
});
